// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"526":"f8978f54","830":"bdcd4585"}[chunkId] + ".chunk.js";
};